import React from "react";
import { useSpring, animated } from "react-spring";
import { useState, useEffect } from "react";
import udokaimg from '../../../image/my office.jpg';
import udokaimage from '../../../image/udoka.png'
const HeroImg = () => {

    const[bubbles, setBubbles]= useState(false);
    const changeposition =()=>{
        setBubbles(!bubbles);
       
    }

useEffect(()=>{
    const intervalId = setInterval(changeposition,6000);
    return ()=> clearInterval(intervalId);
},[bubbles])

   
    const moverightbubble = useSpring({
        opacity:bubbles?1:0,
        transform:bubbles?'translateX(0)':'translateX(100%)',
        config:{duration:5000}
    
    })
    const fade = useSpring({
        transform:bubbles?'translateX(-100%)':'translateX(0)',
        opacity:bubbles?0:1,
        config:{duration:5000}
    
    })
    return (
        <div className="relative flex flex-col w-full md:h-full h-[50%] justify-between items-center md:w-[50%]">
            <div  className=" w-full">
                <animated.div style={moverightbubble} className="w-20 h-20 bg-yellow-500 rounded-full"></animated.div>
            </div>
            <div className="flex w-full justify-end">
                <animated.div style={fade}  className="w-20 h-20 bg-white rounded-full"></animated.div>
            </div>
            <div className="flex w-full justify-start z-40">
                <animated.div style={moverightbubble}  className="w-20 h-20 bg-yellow-500 rounded-full"></animated.div>
            </div>
            <img src={udokaimage} alt="udokaimg" className="object-contain absolute w-full h-full rounded-b-xl " />

        </div>
    );
}

export default HeroImg;